module.exports = __webpack_public_path__ + "static/img/entranceIcon.f51a11a.eae7cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/entranceIcon.f51a11a.png
// module id = UHZG
// module chunks = 0